<template>
    <div id="read-terms" @click.prevent="toggle" class="form-check invoice">
        <div class="checkbox-container" v-bind:class="{ active: accepted }">
            <i class="material-icons">check</i>
        </div>
        <label class="form-check-label">
            {{ label }}
        </label>
    </div>
</template>

<script>
    export default {
        name: "ConfirmToggle",
        props: {
            label: String
        },
        data() {
          return {
              accepted: false
          }
        },
        methods: {
            toggle() {
                this.accepted = !this.accepted;
                this.$emit('input', this.accepted);
            }
        }
    }
</script>

<style scoped>
    .form-check.invoice {
        margin-top: 0px;
    }
</style>